import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InMemoryProductPricelists } from '../models/in-memory-product-pricelists';
import { PricelistService } from './pricelist.service';
import { ProductPricelist } from '../models/product-pricelist';

@Injectable()
export class PricelistInMemoryService implements PricelistService {

  private _inMemoryProductPricelists = new InMemoryProductPricelists();

  getPricelistById(pricelistId: number): Observable<ProductPricelist> {
    const pricelist = this._inMemoryProductPricelists.items.find(item => item.id === pricelistId);
    return of(pricelist);
  }

  getDefaultPricelist(): Observable<ProductPricelist> {
    const pricelist = this._inMemoryProductPricelists.items.find(item => item.id === 1);
    return of(pricelist);
  }
}
